import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

import { Outlet } from 'react-router-dom';
import ProjectTemplate from '../../components/projectmng/ProjectTemplate';
import ProjectInfoContainer from './info/ProjectInfoContainer';
import { viewProject } from '../../modules/projectModule/project';
import { unloadProject } from '../../modules/projectModule/project';
import { listProjectCosts } from '../../modules/projectModule/projectCosts';

const ProjectContainer = ({ pageUrl, id: propsId }) => {
  const routeParams = useParams();
  let navigate = useNavigate();

  const id = propsId || routeParams.id;
  const dispatch = useDispatch();
  const { project, error, loading } = useSelector(
    ({ projectModule, loading }) => ({
      project: projectModule.project.project,
      error: projectModule.project.error,
      loading: loading['project/VIEW_PROJECT'],
    }),
  );

  useEffect(() => {
    dispatch(viewProject(id));
    dispatch(listProjectCosts(id)); //원가산출

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadProject());
    };
  }, [dispatch, id]);

  const handleGoBack = () => {
    navigate(`${pageUrl}`);
  };

  return (
    <>
      <ProjectTemplate project={project} loading={loading} error={error}>
        <ProjectInfoContainer handleGoBack={handleGoBack} />
      </ProjectTemplate>
      <Outlet />
    </>
  );
};

export default ProjectContainer;
